// Bonus points on the Points page (points slice 4c, docs/school-carnivals-points-slice-4c.md in the portal
// repo): the lines an Admin adds to a house for what the timing cannot score, negative for a deduction.
// The checks are the server's (BonusPointsRules), made here first so the popup can say what is wrong
// before anything is sent, in the school's word for a house.

export const MAX_BONUS_POINTS = 1000;
export const MAX_REASON_LENGTH = 200;

// The points typed in the popup, as a number, or null when they are not a number.
export const parseBonusPoints = (text) => {
  if (text === null || text === undefined || String(text).trim() === '') return null;
  const points = Number(text);
  return Number.isFinite(points) ? points : null;
};

// The message for the first problem with a line, or null when it may be saved. `words` are the school's
// words for a house (utils/teamLabel.js).
export const bonusPointsProblem = ({ teamId, points, reason }, words) => {
  if (!teamId) return `Choose a ${words.lower.team}.`;
  const value = parseBonusPoints(points);
  if (
    value === null ||
    value === 0 ||
    Math.abs(value) > MAX_BONUS_POINTS ||
    !Number.isInteger(value * 2)
  ) {
    return 'Points must be from -1000 to 1000, in whole or half points, and not 0.';
  }
  const cleaned = (reason || '').trim();
  if (cleaned.length === 0 || cleaned.length > MAX_REASON_LENGTH) {
    return 'Enter a reason of up to 200 characters.';
  }
  return null;
};

// "10 points", "1 point", "-1 point", "0.5 points".
export const pointsInWords = (points) => {
  const value = Number(points);
  const shown = String(Math.round(value * 100) / 100);
  return `${shown} ${Math.abs(value) === 1 ? 'point' : 'points'}`;
};

// The line in the delete popup: "Wattle: 10 points, Tug of war 1st."
export const bonusPointsLineText = (houseName, points, reason) =>
  `${houseName}: ${pointsInWords(points)}, ${reason}${/[.!?]$/.test(reason || '') ? '' : '.'}`;

// The school's houses in its own order (MeetPointsDashboardDto.houses lists them best first), for the
// popup's list.
export const housesInOwnOrder = (houses) =>
  [...(houses || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
